module.exports = __webpack_public_path__ + "img/jkl_visual.9d5bd862.jpg";